<template>
  <div class="meta-data">
    <div class="created-at-container">
      <FriedParagraph class="created-at" :size="ParagraphSize.Small">
        {{ localizedDate }}
      </FriedParagraph>
      <FriedParagraph class="created-at" :size="ParagraphSize.Small">
        {{ localizedTime }}
      </FriedParagraph>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';
import { DateTime } from 'luxon';
import { ParagraphSize } from '@getaccept/fried-tofu';
import { t } from '../../helpers/translation.helper';
import { DateHelper } from '../../helpers/date.helper';

export default defineComponent({
  props: {
    createdAt: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const localizedDate = computed(() => {
      if (!props.createdAt) {
        return '';
      }

      const date = DateTime.fromMillis(props.createdAt);

      if (DateHelper.isToday(date)) {
        return t('Today').toString();
      }
      if (DateHelper.isYesterday(date)) {
        return t('Yesterday').toString();
      }

      return date.toLocaleString(DateTime.DATE_SHORT);
    });

    const localizedTime = computed(() => {
      if (!props.createdAt) {
        return '';
      }

      const date = DateTime.fromMillis(props.createdAt);

      return date.toLocaleString(DateTime.TIME_SIMPLE);
    });

    return { localizedDate, localizedTime, ParagraphSize };
  },
});
</script>
<style lang="scss" scoped>
.meta-data {
  display: flex;
  align-self: flex-start;

  .created-at-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    .created-at {
      color: var(--gray-60);
      white-space: nowrap;
    }
  }
}
</style>
